import $ from "cash-dom"

export default class FoldModule {

    static name = 'fold'

    constructor(node) {

        const blockId = $(node).parents('.block').first().attr('id');
        const isInsideLayer = $(node).parents('.layer').length;

        $(node).on('click', '.foldbutton', (e) => {

            //update deep anchor link (not in layers)
            if(!isInsideLayer && blockId) {
                let href = window.location.pathname;
                if(!$(node).hasClass('active')) {
                    href += '#' + blockId + '/' + $(node).attr('id');
                }
                
                window.history.replaceState(null, '', href);
            }

            openNode(e);
        });
        $(node).on('deepanchor', function(e) {
            if($(node).hasClass('active')) return;
            openNode(e);
        });

        function openNode(e) {

            //if($(node).hasClass('active')) return;

            $(node)
                .toggleClass('active')
                .siblings()
                .removeClass('active');
        }
    }
}